export default __webpack_public_path__ + "static/media/iron_islands.bcbca871.jpg";